"use client";

import { useMutation, useQueryClient } from "@tanstack/react-query";
import type { CreateFeedbackCollectionRequest } from "@/generated/fastapi";
import { useAuth } from "@/state/globalStore";
import { createFeedbackLink } from "../api/createFeedbackLink";
import { feedbackKeys } from "../queries/keys";

export default function useCreateFeedbackLinkMutation() {
  const { accessToken } = useAuth();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (request: CreateFeedbackCollectionRequest) =>
      createFeedbackLink(accessToken, request),
    onSuccess: async () => {
      await queryClient.invalidateQueries({ queryKey: feedbackKeys.links() });
    },
  });
}
